import { createContext, useCallback, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext({
    colorScheme: 'system',
    setColorScheme: () => {},
    applyBranding: () => {},
    loadBranding: () => {},
});

export function ThemeContextProvider({ children }) {
    const [colorScheme, setColorSchemeState] = useState(
        () => localStorage.getItem('colorScheme') || 'system'
    );

    useEffect(() => {
        const root = document.documentElement;
        const apply = isDark => root.setAttribute('data-theme', isDark ? 'dark' : 'light');

        if (colorScheme === 'dark')  { apply(true);  return; }
        if (colorScheme === 'light') { apply(false); return; }

        // 'system' — mirror OS preference and track changes
        if (!window.matchMedia) { apply(false); return; }
        const mq = window.matchMedia('(prefers-color-scheme: dark)');
        apply(mq.matches);
        const handler = e => apply(e.matches);
        mq.addEventListener('change', handler);
        return () => mq.removeEventListener('change', handler);
    }, [colorScheme]);

    const setColorScheme = useCallback(scheme => {
        setColorSchemeState(scheme);
        localStorage.setItem('colorScheme', scheme);
    }, []);

    // Company CI colours are intentionally NOT applied to the app UI, which always uses the
    // Global.css tokens; they are consumed by the backend's PDF and report generation.
    const applyBranding = useCallback(() => {}, []);
    const loadBranding = useCallback(() => {}, []);

    return (
        <ThemeContext.Provider value={{ colorScheme, setColorScheme, applyBranding, loadBranding }}>
            {children}
        </ThemeContext.Provider>
    );
}

export function useTheme() {
    return useContext(ThemeContext);
}
